const state = {
    document_blocks: [],
    document_block: {},
    document_types: [],
    document_block_filters: {},
}

export default state;
